module.exports = __webpack_public_path__ + "media/images/how_it_works/5-835b60a14ac93cfef737469c31c25dfb.svg";